<template>
    <div class="versions">
        <div class="tableCont">
            <!-- <el-drawer title="高级搜索"
                 :visible.sync="drawerVisible"
                 size="320px"
                 class="drawerCont"
                 ref="drawer"
                 :wrapperClosable="false">
        <el-scrollbar class="scrollbar">
          <el-form :model="searchForm"
                   class="drawerForm"
                   label-width="120">
            <el-form-item label="发布标题"
                          size="small">
              <el-input clearable
                        placeholder="请输入发布标题"
                        maxlength="50"
                        size="small"
                        v-model="searchForm.title"
                        @keyup.enter.native="versions(1)">
              </el-input>
            </el-form-item>
            <el-form-item label="版本号"
                          size="small">
              <el-input clearable
                        placeholder="请输入版本号"
                        maxlength="50"
                        size="small"
                        v-model="searchForm.version"
                        @keyup.enter.native="versions(1)">
              </el-input>
            </el-form-item>
            <el-form-item label="发布日期"
                          size="small">
              <el-date-picker v-model="searchForm.publish_time"
                              type="date"
                              placeholder="发布日期"
                              size="small"
                              value-format="yyyy-MM-dd"
                              format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-form>
        </el-scrollbar>
        <div class="drawer-footer">
          <el-button type="primary"
                     icon="el-icon-search"
                     size="small"
                     @click="versions(1)">
            查询
          </el-button>
          <el-button type="danger"
                     icon="el-icon-circle-close"
                     size="small"
                     @click="clean">
            清空
          </el-button>
        </div>
      </el-drawer> -->
            <div class="searchCont">
                <div class="searchContLeft">
                    <el-form
                        :inline="true"
                        :model="searchForm"
                        label-width="120"
                    >
                        <el-form-item label="发布标题" size="mini">
                            <el-input
                                clearable
                                placeholder="请输入发布标题"
                                maxlength="50"
                                size="mini"
                                v-model="searchForm.title"
                                @keyup.enter.native="versions(1)"
                            >
                            </el-input>
                        </el-form-item>
                        <!-- <el-form-item label="版本号" size="mini">
                            <el-input
                                clearable
                                placeholder="请输入版本号"
                                maxlength="50"
                                size="mini"
                                v-model="searchForm.version"
                                @keyup.enter.native="versions(1)"
                            >
                            </el-input>
                        </el-form-item> -->
                        <el-form-item
                            label="项目名称"
                            size="small"
                            prop="project_id"
                        >
                            <el-select
                                v-model="searchForm.project_id"
                                placeholder="请选择项目名称"
                                clearable
                                filterable
                                @change="versions(1)"
                            >
                                <el-option
                                    v-for="item in systemList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="发布日期" size="mini">
                            <el-date-picker
                                v-model="searchForm.publish_time"
                                prefix-icon="el-icon-date theme-color"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="一"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                size="mini"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                @change="versions"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-form>
                    <el-button
                        icon="el-icon-search"
                        size="mini"
                        type="primary"
                        style="margin-right: 10px"
                        @click="versions(1)"
                    ></el-button>
                    <div v-if="this.menuAuth">
                        <template v-for="item in menuAuth">
                            <el-button
                                :key="item.id"
                                type="primary"
                                :icon="item.icon"
                                size="mini"
                                @click="authFunc(item.funcName)"
                            >
                                {{ item.name }}
                            </el-button>
                        </template>
                    </div>
                    <div v-else></div>
                </div>
                <!-- <el-button class="el-icon-s-fold searchDrawer"
                   type="text"
                   size="mini"
                   @click="drawerVisible = true">高级搜索</el-button> -->
            </div>
            <div class="table" :style="{ height: screen }">
                <el-table :data="tableData" highlight-current-row height="100%">
                    <!-- <el-table-column width="60" align="center" label="序号">
                        <template slot-scope="scope">
                            <span>{{
                                (paginationData.page - 1) *
                                    paginationData["per-page"] +
                                scope.$index +
                                1
                            }}</span>
                        </template>
                    </el-table-column> -->
                    <el-table-column
                        type="selection"
                        align="left"
                        :fixed="checkFixed"
                    >
                    </el-table-column>
                    <el-table-column
                        label="项目名称"
                        property="project_name"
                        align="left"
                    >
                    </el-table-column>
                    <el-table-column
                        label="发布标题"
                        property="title"
                        align="left"
                    >
                    </el-table-column>
                    <el-table-column
                        label="版本号"
                        property="version"
                        align="left"
                    >
                    </el-table-column>
                    <el-table-column
                        label="发布日期"
                        property="publish_time"
                        align="left"
                    >
                    </el-table-column>
                    <el-table-column
                        label="创建人"
                        property="user_name"
                        align="left"
                    >
                    </el-table-column>
                    <el-table-column
                        label="创建时间"
                        property="create_time"
                        align="left"
                    >
                    </el-table-column>
                    <!-- <el-table-column label="状态"
                           property="site_url"
                           align="center">
            <template slot-scope="scope">
              <el-tag size="mini"
                      :type="scope.row.status==1?'success':'danger'">
                {{scope.row.status_cn}}
              </el-tag>
            </template>
          </el-table-column> -->
                    <el-table-column
                        label="操作"
                        align="left"
                        width="200"
                        :fixed="operationFixed"
                    >
                        <template slot-scope="scope">
                            <div class="operation-btns">
                                <span
                                    v-for="item in scope.row.authority"
                                    :key="item.id"
                                >
                                    <el-button
                                        v-if="item.status_flag != 4"
                                        type="text"
                                        size="small"
                                        class="color-blue"
                                        :class="
                                            item.name == '删除' ? 'redText' : ''
                                        "
                                        @click="rowDo(scope.row, item)"
                                        >{{ item.name }}</el-button
                                    >
                                    <popConfirm
                                        v-else
                                        :title="item.name"
                                        :buttonText="item.name"
                                        @confirm="rowDo(scope.row, item)"
                                    >
                                    </popConfirm>
                                </span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <pagination
                :paginationData="paginationData"
                @paginationChange="paginationChange"
            ></pagination>
        </div>
        <versionsAdd :addVisible.sync="addVisible" :systemList="systemList"></versionsAdd>
        <edit
            :editVisible.sync="editVisible"
            :tableItem="tableItem"
            :systemList="systemList"
        ></edit>
        <detail
            :detailVisible.sync="detailVisible"
            :tableItem="tableItem"
        ></detail>
        <!-- <detail :detailVisible.sync="detailVisible"
            :tableItem.sync="tableItem"></detail> -->
    </div>
</template>
<script>
import * as oaApi from "@/http/oaApi.js";
import { tableMixin } from "@/utils/tableMixins.js";
import pagination from "@/comon/components/pagination";
import edit from "./versions/edit";
import detail from "./versions/detail";
import popConfirm from "@/comon/components/popConfirm";
// import detail from "./carriers/detail";
export default {
    mixins: [tableMixin],
    data() {
        return {
            searchForm: {
                title: "",
                version: "",
                publish_time: "",
                project_id: "",
            },
            tableData: [],

            paginationData: {
                page: 1,
                "per-page": 20,
                total: "",
            },

            tableItem: {},
            addVisible: false,
            editVisible: false,
            detailVisible: false,
            drawerVisible: false,
            systemList: [
                /* {
                    label: "OA",
                    value: "OA",
                },
                {
                    label: "WMS",
                    value: "WMS",
                },
                {
                    label: "ERP",
                    value: "ERP",
                },
                {
                    label: "magento",
                    value: "magento",
                }, */
            ],
        };
    },
    methods: {
        add() {
            this.addVisible = true;
        },
        clean() {
            this.searchForm = {
                title: "",
                version: "",
                publish_time: "",
            };
        },
        closeDrawer() {
            this.drawerVisible = false;
        },
        /**
         * 获取table
         */
        versions(page) {
            page ? (this.paginationData.page = 1) : "";
            oaApi
                .versions(
                    {
                        ...this.paginationData,
                        ...this.searchForm,
                        menu_id: this.menu_id,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.tableData = res.data;
                        this.paginationData.total = res.total;
                        this.closeDrawer();
                    }
                });
        },
        paginationChange(paginationData) {
            this.paginationData = paginationData;
            this.versions();
        },
        /**
         * 根据table数据循环事件分发
         */
        rowDo(row, item) {
            if (item.name == "编辑") {
                this.editVisible = true;
                this.tableItem = row;
            } else if (item.name == "删除") {
                /* this.$confirm(`确定${item.name}?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => */
                        oaApi.versions({}, "delete", row.id).then((res) => {
                            if (res) {
                                if (res.code == 200) {
                                    this.$message.success(`${item.name}成功`);
                                    this.versions();
                                }
                            }
                        })
                    /* )
                    .catch(() => {
                        this.$message.info("已取消操作");
                    }); */
            } else if (item.name == "查看") {
                this.detailVisible = true;
                this.tableItem = row;
            }
        },
        authFunc(funcName) {
            this[funcName]();
        },
        /**
         * 获取项目下拉菜单
         */
        projectSelect() {
            oaApi.projectSelect({}, "get").then((res) => {
                if (res.code == 200) {
                    this.systemList = res.data;
                }
            });
        },
    },
    mounted() {
        this.versions();
        this.projectSelect();
    },
    components: {
        pagination: pagination,
        popConfirm: popConfirm,
        versionsAdd: () => import("./versions/add"),
        edit: edit,
        detail: detail,
    },
    computed: {
        menuAuth() {
            return this.$store.state.menu.menuAuth;
        },
        staffList() {
            return this.$store.state.index.staffList;
        },
        menu_id() {
            return this.$store.state.menu.menu_id
                ? this.$store.state.menu.menu_id
                : localStorage.getItem("menu_select");
        },
        screen() {
            return `calc(100% - 40px - 40px)`;
        }
    },
};
</script>
<style lang="scss">
.versions {
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;

    .tableCont {
        width: 100%;
        height: 100%;
        border-left: 1px solid #eee;
        padding: 0 20px;
        box-sizing: border-box;
        .table {
            width: 100%;
            .el-scrollbar__wrap {
                overflow-x: hidden;
            }
        }
    }
}
</style>
